var t = TypeError, n = function(r, e) {
  if (r < e)
    throw new t("Not enough arguments");
  return r;
};
export {
  n as v
};
